import React from "react";
import { Phone, MapPin, Star, Clock, ShieldCheck, Calendar, ChevronRight } from "lucide-react";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { businessInfo, heroImage, stats } from "../data/mock";

const Hero = () => {
  return (
    <section className="relative overflow-hidden">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${heroImage})`, backgroundPosition: "center 40%" }}
      />
      <div className="absolute inset-0 hero-overlay" />

      <div className="relative max-w-7xl mx-auto px-4 pt-16 pb-24 md:pt-24 md:pb-32">
        <div className="max-w-3xl">
          <Badge className="bg-green-600 hover:bg-green-600 text-white border-0 mb-5 px-3 py-1.5 rounded-full text-xs font-bold tracking-wide">
            <ShieldCheck className="w-3.5 h-3.5 mr-1.5" /> STAR-CERTIFIED SMOG STATION
          </Badge>

          <h1 className="text-white font-black tracking-tight leading-[1.05] text-4xl sm:text-5xl md:text-6xl lg:text-7xl mb-6">
            Smog Check Near Me —
            <span className="block text-green-500 mt-2">In &amp; Out in 20 Minutes.</span>
          </h1>

          <p className="text-slate-200 text-lg md:text-xl max-w-2xl mb-8 leading-relaxed">
            Hamilton's Star Smog Check is Novato and Marin County's fastest, most trusted STAR-certified smog station. Two bays, two technicians, and a price-match guarantee — come see why locals leave 5-star reviews.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 mb-10">
            <Button asChild size="lg" className="bg-green-600 hover:bg-green-700 text-white font-bold text-base h-12 px-6">
              <a href={businessInfo.bookingUrl} target="_blank" rel="noreferrer">
                <Calendar className="w-5 h-5 mr-2" /> Book Appointment
                <ChevronRight className="w-4 h-4 ml-1" />
              </a>
            </Button>
            <Button asChild size="lg" variant="outline" className="bg-white/10 backdrop-blur border-white/30 text-white hover:bg-white hover:text-slate-900 font-bold text-base h-12 px-6">
              <a href={`tel:${businessInfo.phoneRaw}`}>
                <Phone className="w-5 h-5 mr-2" /> Call {businessInfo.phone}
              </a>
            </Button>
          </div>

          <div className="flex flex-wrap items-center gap-x-6 gap-y-3 text-white/90 text-sm">
            <div className="flex items-center gap-1.5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
              ))}
              <span className="font-semibold ml-1">5.0 on Google</span>
            </div>
            <div className="flex items-center gap-1.5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
              ))}
              <span className="font-semibold ml-1">5.0 on Yelp</span>
            </div>
            <div className="flex items-center gap-2"><Clock className="w-4 h-4 text-green-400" /> Open now until 5:30 PM</div>
            <div className="flex items-center gap-2"><MapPin className="w-4 h-4 text-green-400" /> 1032 First St, Novato</div>
          </div>
        </div>
      </div>

      {/* Stats bar */}
      <div className="relative bg-white border-t border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 py-6 grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <div className="text-2xl md:text-3xl font-black text-slate-900">{s.value}</div>
              <div className="text-xs md:text-sm text-slate-500 font-medium mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
